'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidSad = function IoAndroidSad(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm19.8 22.5c3.5 0 6.4 2 7.9 5h-15.9c1.5-3 4.4-5 8-5z m0-18.7c8.9 0 16.2 7.3 16.2 16.2s-7.3 16.3-16.2 16.3-16.3-7.4-16.3-16.3 7.3-16.2 16.3-16.2z m0 29.2c7.1 0 12.9-5.8 12.9-13s-5.8-13-12.9-13-13 5.8-13 13 5.8 13 13 13z m5.7-14.6c-1.5 0-2.5-1.1-2.5-2.5s1-2.4 2.5-2.4 2.4 1 2.4 2.4-1 2.5-2.4 2.5z m-11.5 0c-1.4 0-2.4-1.1-2.4-2.5s1-2.4 2.4-2.4 2.5 1 2.5 2.4-1 2.5-2.5 2.5z' })
        )
    );
};

exports.default = IoAndroidSad;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-sad.js
// module id = 1903
// module chunks = 0